import { ReactElement, use } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import TextField from '@mui/material/TextField';

import useWanderingBoundaryPassageRowValidation from 'features/wandering-boundary-settings/hooks/wandering-boundary-passage-row-validation-hook';
import WanderingBoundaryPassageRowProviderContext from 'features/wandering-boundary-settings/providers/contexts/wandering-boundary-passage-row-provider-context';
import styles from './blocking-passage-warning.module.scss';

const NameInputField = (): ReactElement => {
  const { t } = useTranslation('wanderingBoundarySettings');
  const { form, wanderingBoundaryPassage } = use(WanderingBoundaryPassageRowProviderContext);
  const { validationRules } = useWanderingBoundaryPassageRowValidation(wanderingBoundaryPassage);

  return (
    <Controller
      name="name"
      control={form.control}
      rules={validationRules.name}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          label={t('wanderingBoundaryPassageFields.nameLabel')}
          variant="outlined"
          fullWidth
          error={!!error}
          helperText={error?.message}
          slotProps={{
            htmlInput: {
              maxLength: 30,
            },
          }}
          className={styles.nameField}
        />
      )}
    />
  );
};

export default NameInputField;
